/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CommissionsReportRowDto = {
    /**
     * Stable key used for processing payment status
     */
    sourceKey: string;
    policyId: string;
    policy: string;
    mtaVersion?: number | null;
    startDate: string;
    coverTypes: Array<string>;
    transactionType: CommissionsReportRowDto.transactionType;
    commissionRuleApplied: string;
    grossIncome: number;
    adminFee: number;
    adminGst: number;
    brokerFee: number;
    brokerGst: number;
    writeOffAmount: number;
    writeOffType?: string | null;
    commissionTotal: number;
    commissionGst: number;
    overrideCommission: number;
    overrideWriteOff: number;
    overridePercentage: number;
    overrideName?: string | null;
    arCommission: number;
    arWriteOff: number;
    arPercentage: number;
    arAdviser?: string | null;
    adviserRole?: CommissionsReportRowDto.adviserRole | null;
    arFap?: string | null;
};
export namespace CommissionsReportRowDto {
    export enum transactionType {
        NB = 'NB',
        RENEWAL = 'RENEWAL',
        MTAI = 'MTAI',
        MTAD = 'MTAD',
        MTAN = 'MTAN',
        CANCELLATION = 'CANCELLATION',
        MTA_REVERSAL = 'MTA_REVERSAL',
    }
    export enum adviserRole {
        AUTHORISED_REP = 'AUTHORISED_REP',
        QUOTING_ADVISER = 'QUOTING_ADVISER',
        INTERNAL_ADVISER = 'INTERNAL_ADVISER',
    }
}

